import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CreateTangramService {

  youtubeAPI: string = 'https://youtube.googleapis.com/youtube/v3/videos?part=snippet&part=contentDetails'; // To store youtube api
  constructor(private http: HttpClient) { }


  /**
   * Get youtube video detail
   * @param videoId videoId for which video
   */
  getYoutubeVideoDetail(videoId: string) {
    const params = new HttpParams().set("hideHeader", "true").set('interceptorNotNeeded', 'true');
    return this.http.get(`${this.youtubeAPI}&id=${videoId}&key=${environment.youtubeSiteKey}`, { params: params });
  }
  /**
   * Get spotify url detail
   * @param url url of spotify
   */
  getSpotifyUrlDetail(url: string) {
    return this.http.post(`${environment.baseUrl}/pathway/getSpotifyLinkInfo`, { spotifyLink: url });
  }

  /**
   * Get google workspace detail
   * @param data url of spotify
   */
  getGoogleWorkspaceDetails(data: Record<string, any>) {
    return this.http.post(`${environment.baseUrl}/pathway/getWorkspaceInfo`, data);
  }
  
  /**
   * Save video
   * @param video video to be saved (can include thumbnailFile for file upload)
   */
  saveVideo(video) {
    // Check if thumbnail contains File objects
    const hasThumbnailFiles = video.thumbnail && 
    (video.thumbnail.smallURL instanceof File || video.thumbnail.mediumURL instanceof File);
    
    if (hasThumbnailFiles) {
      const formData = new FormData();
      
      // Add all video properties to FormData
      Object.keys(video).forEach(key => {
        if (key === 'thumbnail') {
          // Handle thumbnail with File objects
          if (video.thumbnail.smallURL instanceof File) {
            formData.append('thumbnail[smallURL]', video.thumbnail.smallURL);
          }
          if (video.thumbnail.mediumURL instanceof File) {
            formData.append('thumbnail[mediumURL]', video.thumbnail.mediumURL);
          }
        } else {
          formData.append(key, JSON.stringify(video[key]));
        }
      });
      
      return this.http.post(`${environment.baseUrl}/pathway/video/createUpdate`, formData);
    } else {
      // No thumbnail files, send as regular JSON
      return this.http.post(`${environment.baseUrl}/pathway/video/createUpdate`, video);
    }
  }
  /**
   * Get video detail 
   */
  getVideoDetail(videoId) {
    return this.http.get(`${environment.baseUrl}/dashboard/video/details/${videoId}`);
  }
  /**
   * Get Pathway or video count
   */
  getPathwayOrVideoCount(pathwayId) {
    return this.http.get(`${environment.baseUrl}/pathway/tangramOrVideoCount?pathwayId=${pathwayId}`);
  }

  /**
   * Send invite only invitations
   */
  sendInviteOnlyInvitations(pathwayId: string, emails: { email: string; accessType: string }[], message: string) {
    return this.http.post(`${environment.baseUrl}/pathway/send-invitations`, {
      pathwayId: pathwayId,
      emails: emails,
      message: message
    });
  }
  
}